import CorporateFare from "@mui/icons-material/CorporateFare"
import ObjectCreate from "./create"
import ObjectEdit from "./edit"
import ObjectList from "./list"
import ObjectShow from "./show"
import ObjectFlow from "./flow"
import ObjectMap from "./map"
import Schedule from "./schedule.list"
import ScheduleCreate from "./schedule.create"
import ScheduleEdit from "./schedule.edit"
import ObjectAuditHistoryPage from "./audit"

const options = {
    audit: ObjectAuditHistoryPage,
    list: ObjectList,
    create: ObjectCreate,
    edit: ObjectEdit,
    show: ObjectShow,
    icon: CorporateFare,
    flow: ObjectFlow,
    map: ObjectMap,
    schedules: Schedule,
    schedulecreate: ScheduleCreate,
    scheduleedit: ScheduleEdit
    //recordRepresentation: (record: any)=> `${record.name} (${record.role})`,
}

export default options